import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { DirectionService } from '../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService } from 'src/app/dialog/dialog.service';

import { UsersService } from 'src/app/super-management/user/users.service';

import { FilesService } from "src/app/main-section/printing-table/file.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-processing-file',
  templateUrl: './processing-file.component.html',
  styleUrls: ['./processing-file.component.css'],
  host: {
    class: 'fill-screen-modal-phone'
  }
})
export class ProcessingFileComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading: boolean = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  printingService: string = "";
  file: any;
  isALotOfTime: boolean = true;
  fileType: string = '';
  language: string = 'he';

  /** רשימת התכנות במדריך העריכה (כמו בשאלות נפוצות) */
  readonly editGuideSoftwareKeys = [
    'q-and-a.2.software.illustrator',
    'q-and-a.2.software.photoshop',
    'q-and-a.2.software.indesign',
    'q-and-a.2.software.autocad',
    'q-and-a.2.software.canva',
    'q-and-a.2.software.powerpoint',
    'q-and-a.2.software.revit',
    'q-and-a.2.software.word',
  ];

  isClosed: boolean = false;

  constructor(
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    private usersService: UsersService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private filesSevice: FilesService,
    private translate: TranslateService,
  ) {
    this.file = data.file;
    this.printingService = data.service;
    this.isALotOfTime = data.isALotOfTime ? data.isALotOfTime : true;
  }

  async ngOnInit() {
    this.isLoading = true;
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    // get this.currentLanguage$ from directionService
    this.directionService.currentLanguage$.subscribe((lang) => {
      this.language = lang;
    });

    this.getReducedFormat(this.file);

    this.isLoading = false;
  }

  closeProcessingFileDialog() {
    if (this.isClosed) {
      this.dialogService.onCloseProcessingFileDialog();
    } else {
      this.isClosed = true;
      setTimeout(() => {
        this.dialogService.onCloseProcessingFileDialog();
      }, 2700);
    }
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
  }

  getReducedFormat(file: any) {
    if (!file.fileName || !file.fileName.includes('.')) {
      this.fileType = "Unknown";
      return;
    }
    const type = this.file.fileName.split('.').pop().toLowerCase() ? this.file.fileName.split('.').pop().toLowerCase() : "Unknown";
    if (type) {
      if (type === 'pdf') {
        this.fileType = 'PDF';
      } else if (type === 'jpeg' || type === 'jpg') {
        this.fileType = 'JPEG';
      } else {
        this.fileType = type.toUpperCase();
      }
    } else {
      this.fileType = "Unknown";
    }
  }

  getVeryReducedFormat() {
    if (!this.file.fileName || !this.file.fileName.includes('.')) {
      return "Unknown";
    }
    const type = this.file.fileName.split('.').pop().toLowerCase() ? this.file.fileName.split('.').pop().toLowerCase() : "Unknown";
    if (type === 'pdf') {
      return 'PDF';
    } else if (type === 'jpeg' || type === 'jpg') {
      return 'JPEG';
    } else if (type === 'png') {
      return 'PNG';
    } else {
      return "Unknown";
    }
  }


  goToEditInstructions() {
    this.dialogService.onCloseProcessingFileDialog();
    this.router.navigate(['/edit']);
  }

  // ===============
}
